export const eventHandlers = {
	SHOPPING_CART_PAGE_VIEW: 'SHOPPING_CART_PAGE_HIT',
};
